import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ValidatorService {
  matchPasswords(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (!control || !matchingControl) return;

      const errors = { ...(matchingControl.errors || {}) };

      if (!control.value || !matchingControl.value) {
        delete errors['passwordMatch'];
      } else if (control.value !== matchingControl.value) {
        errors['passwordMatch'] = true;
      } else {
        delete errors['passwordMatch'];
      }

      matchingControl.setErrors(Object.keys(errors).length ? errors : null);
    };
  }
}
